module.exports = "images/playFocused.07c2e889.png";